var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-16"},[_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":""}}),_c('h5',{staticClass:"text-center grey--text pt-3 mb-0"},[_vm._v(" "+_vm._s(_vm.$t('appointment.table.loading'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }